<div class="relative w-full h-full flex justify-center items-center bg-white">잘못된 접근 입니다.</div>
